<template>
    <div class="container-main">
        <div class="row justify-content-center align-items-center py-2 my-3">
            <p class="page-title-header-text mb-0">Select a {{ selectedSport.toLowerCase() }} league:</p>
        </div>
        <hr class="line-break">
        <div class="leagues-container">
            <div class="league-icon-box" v-for="(availableLeague, index) in orderedAvailableLeagues" :key="index"
                 v-bind:class="[leagueHasActiveRound(availableLeague.name) ? activeLeagueClass : inactiveLeagueClass]"
                 v-on:click.stop="onLeagueSelected(availableLeague.name)">
                <div class="league-icon-wrapper">
                    <img class="league-icon" :src="getImage(availableLeague.iconPath)" alt="">
                    <p class="icon-text">Predict {{ availableLeague.displayName === "m" ? 'T20 World Cup' : availableLeague.displayName}}</p>
                </div>
            </div>
            <div class="league-icon-box" style="z-index: -2"
                 v-if="this.selectedSportConfig.availableLeagues.length % 2 !== 0">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {ActiveSports} from "@/config/activeSports";
    import ScorePredictorService from "../services/scorePredictorService";

    export default {
        name: "Leagues",
        data() {
            return {
                activeLeagueClass: 'active-league-icon-box',
                inactiveLeagueClass: 'inactive-league-icon-box',
                selectedSportConfig: [],
                orderedAvailableLeagues: [],
                activeSports: [
                    {
                        name: 'Soccer',
                        iconPath: 'football-category-icon-white.png',
                        sportId: 1,
                        availableLeagues: []
                    },
                    {
                        name: 'Rugby',
                        iconPath: 'rugby-category-icon-white.png',
                        availableLeagues: []
                    },
                    {
                        name: 'Basketball',
                        iconPath: 'basketball-category-icon-white.png',
                        availableLeagues: []
                    },
                    {
                        name: 'Cricket',
                        iconPath: 'cricket-category-icon-white.png',
                        sportId: 3,
                        availableLeagues: []
                    },
                ]
            }
        },
        computed: mapState(['selectedSport', 'sportsWithActiveRounds']),
        methods: {
            ...mapMutations(['setSelectedLeague']),

            setOrderedActiveLeagues() {
                this.selectedSportConfig.availableLeagues.forEach((league) => {
                    if (this.leagueHasActiveRound(league.name)) this.orderedAvailableLeagues.push(league)
                });
                this.selectedSportConfig.availableLeagues.forEach((league) => {
                    if (!this.leagueHasActiveRound(league.name)) this.orderedAvailableLeagues.push(league)
                })
            },
            getImage(imagePath) {
                return require(`../assets/${imagePath}`);
            },
            leagueHasActiveRound(league) {
                return this.leaguesWithActiveRounds.has(league);
            },
            onLeagueSelected(league) {
                if (this.leaguesWithActiveRounds.has(league)) {
                    this.setSelectedLeague(league);
                    this.$router.push('rounds');
                }
            }
        },
       async created() {
           await this.activeSports.asyncForEach(async (sport) => {
               const activeLeagues = await ScorePredictorService.getLeagues(sport.sportId, 1);
               if (activeLeagues.length > 0) {
                   activeLeagues.forEach((league) => {
                       if (league.HasActiveRound > 0) {
                           const words = league.DisplayName.split(' ');
                           sport.availableLeagues.push({
                               name: `${league.DisplayName}`,
                               displayName: `${words[0]}`,
                               iconPath: `leagues/${league.Name}.png`
                           })
                       }
                   })
               }
           });
            this.selectedSportConfig = this.activeSports.find((sport) => sport.name === this.selectedSport);
            this.leaguesWithActiveRounds = this.sportsWithActiveRounds.get(this.selectedSport);
            this.setOrderedActiveLeagues();
        }
    }
</script>

<style scoped lang="scss">
    .container-main {
        margin-left: 20px;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
    }

    .tab-bar-img {
        height: 6vh;
    }

    .has-active-predictions-sidebar {
        position: absolute;
        display: flex;
        width: 4vw;
        right: -4vw;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        height: 100%;
        writing-mode: vertical-rl;
        background-color: $sports-icon-hasPredictions-color;
        border-radius: 5px;
    }

    .edit-text {
        padding: 0;
        margin: 0;
        font-size: 2vh;
    }

    .chev-down-white {
        margin-left: 1vw;
        color: $chev-down-earn-points-color !important;
    }

    .leagues-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        padding-bottom: 2rem;
    }

    .league-icon-box {
        width: 35vw !important;
        height: 35vw !important;
        margin: 10px;
        padding: 10px;
        background-color: $icon-container-background-color;
        border-radius: 5px;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, .7),
        0 -0.25rem 1.5rem $icon-container-background-color inset,
        0 0.75rem 0.5rem rgba(238, 238, 238, 0.4) inset,
        0 0.25rem 0.5rem 0 #eceaea inset;
    }

    @media screen and (min-width: 900px) {
        .league-icon-box {
            width: 20vw !important;
            height: 20vw !important;
            margin: 35px;
        }
    }

    .active-league-icon-box:hover {
        cursor: pointer;
    }

    .inactive-league-icon-box {
        opacity: 0.4;
    }

    .league-icon-wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    .icon-text-wrapper {
        height: 20%;
        width: 100%;
    }

    .league-icon-box {
        padding: 10px;
        width: 100%;
        height: 100%;
    }

    .league-icon {
        height: auto;
        width: 50%;
    }

    .icon-text {
        font-size: 0.8rem;
        margin: 0.5rem 0 0 0;
    }

    .icon-text {
        font-size: 0.8rem;
        margin: 0.5rem 0 0 0;
        bottom: 0;
    }

    .line-break {
        color: $line-break-color;
    }

</style>
